import M from '@materializecss/materialize';
import { useCallback, useEffect, useRef } from 'react';

const SelectAddressModal = ({ isOpen, setIsOpen, addressList, setAddress }) => {
  const ref = useRef(null);

  useEffect(() => {
    const { current } = ref;
    if (!current) return;

    M.Modal.init(current, {
      onCloseEnd: () => setIsOpen(false),
    });

    return () => M.Modal.getInstance(current)?.destroy();
  }, [ref.current]);

  const getModal = useCallback(
    () => (ref.current ? M.Modal.getInstance(ref.current) : null),
    [ref.current]
  );
  const openModal = useCallback(() => getModal()?.open(), [getModal]);
  const closeModal = useCallback(() => getModal()?.close(), [getModal]);

  useEffect(() => {
    isOpen ? openModal() : closeModal();
  }, [isOpen]);

  return (
    <div ref={ref} className="modal">
      <div className="modal-content">
        <h5 className="center">Select An Address</h5>
        {addressList?.map(address => {
          const {
            id,
            addressLineOne,
            addressLineTwo,
            addressLineThree,
            city,
            state: { code },
            postalCode,
            isDefault,
          } = address;
          return (
            <div
              key={id}
              className="card"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setAddress(address);
                setIsOpen(false);
              }}
            >
              <div className="card-content">
                <div className="row">
                  <p className="right">{isDefault ? 'Default Address' : ''}</p>
                </div>
                <div className="row">
                  <p>
                    <b>{addressLineOne}</b>
                  </p>
                  {addressLineTwo && <p>{addressLineTwo}</p>}
                  {addressLineThree && <p>{addressLineThree}</p>}
                  <p>
                    {city}, {code} {postalCode}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectAddressModal;
